import { ApplicationMessagesAction } from "./application-message.action";
import { InitializerAction } from "../initializer/initiliazer.action";


export class ApplicationMessagesState {
    messages: Array<Date>;
    lastMessage: Date
}

export const initialState: ApplicationMessagesState = {
    messages: [],
    lastMessage: null
}


export function ApplicationMessagesReducer(state: ApplicationMessagesState = initialState, action: ApplicationMessagesAction){

    switch (action.type) {
        case ApplicationMessagesAction.genericError:
            return{...state, ...{messages: [...state.messages, new Date()]}};

        case ApplicationMessagesAction.genericErrorStarted:
            return {...state, ...{lastMessage: new Date()} };
        
        case ApplicationMessagesAction.genericErrorCompleted:
            return {...state, ...{lastMessage: null}};
        
        case InitializerAction.resetUserRelatedData:
            return {...state, ...{messages: initialState.messages }};

        default:
            return state;
    }
};
